export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

export const SWITCH_SUBSCRIPTION_REQUEST = 'SWITCH_SUBSCRIPTION_REQUEST';
export const SWITCH_SUBSCRIPTION_SUCCESS = 'SWITCH_SUBSCRIPTION_SUCCESS';
export const SWITCH_SUBSCRIPTION_FAILURE = 'SWITCH_SUBSCRIPTION_FAILURE';
